import { Sparkles } from "lucide-react";

export const PlusBadge = ({ testId = "plus-seller-badge", compact = false }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 border border-[#C26B51] bg-[#1A3626] ${compact ? "px-2 py-1 text-[10px]" : "px-3 py-1.5 text-xs"} font-bold uppercase tracking-[0.18em] text-white shadow-[2px_2px_0px_0px_rgba(194,107,81,1)]`}>
    <Sparkles size={compact ? 11 : 13} /> PLUS SELLER
  </span>
);